var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row mx-0"},[_c('ActivityEngagementTable',{attrs:{"activities":_vm.activityList,"activityStats":_vm.activityStats,"rooms":_vm.projectRooms,"loadingComplete":_vm.loadingComplete,"error":_vm.error}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }